/**
 * PhotoUpload — hidden file input for photo search
 */

import { EVENTS } from '../core/events.js';

const ACCEPTED_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 MB

export default class PhotoUpload {
  /**
   * @param {Object} eventBus - EventBus instance
   */
  constructor(eventBus) {
    this._eventBus = eventBus;
    this._inputEl = null;
  }

  /**
   * Create the hidden file input
   */
  render() {
    this._inputEl = document.createElement('input');
    this._inputEl.type = 'file';
    this._inputEl.accept = ACCEPTED_TYPES.join(',');
    this._inputEl.style.display = 'none';

    this._inputEl.addEventListener('change', () => {
      const file = this._inputEl.files && this._inputEl.files[0];
      if (!file) return;

      // Validate file type
      if (!ACCEPTED_TYPES.includes(file.type)) {
        console.warn('[GarderoboSearch] Invalid file type:', file.type);
        return;
      }

      // Validate file size
      if (file.size > MAX_FILE_SIZE) {
        console.warn('[GarderoboSearch] File too large:', file.size);
        return;
      }

      this._eventBus.emit(EVENTS.PHOTO_UPLOAD, { file });

      // Reset input so the same file can be selected again
      this._inputEl.value = '';
    });

    document.body.appendChild(this._inputEl);
  }

  /**
   * Trigger the file dialog
   */
  trigger() {
    if (this._inputEl) {
      this._inputEl.click();
    }
  }

  destroy() {
    if (this._inputEl && this._inputEl.parentNode) {
      this._inputEl.parentNode.removeChild(this._inputEl);
    }
    this._inputEl = null;
  }
}
